const isProd = process.env.DOMAIN_ENV === 'prod';
const isDev = process.env.DOMAIN_ENV === 'dev';

export const API_DOMAIN = isProd
  ? 'https://apiv4.720yun.com'
  : 'https://api-test.720yun.com';

export const API_QINIU_DOMAIN = isProd
  ? 'https://api-qiniuv2.720yun.com'
  : 'https://api-qiniu-test.720yun.com';

export const MEDIA_DOMAIN = isDev
  ? '/media'
  : 'https://ssl-media.720static.com/@';

export const MEDIA_DOMAIN2 = isProd
  ? 'https://ssl-media2.720static.com'
  : 'https://ssl-media0.720static.com';

const thumbDomainDev = isDev ? '/thumb' : 'https://ssl-thumb0.720static.com';

export const THUMB_DOMAIN = isProd
  ? 'https://ssl-thumb2.720static.com'
  : thumbDomainDev;

export const SOCKET_DOMAIN = isProd
  ? 'https://socketv4.720yun.com'
  : 'https://socket-test.720yun.com';

export const HOST = isProd
  ? 'https://www.720yun.com'
  : 'https://test.720yun.com';

export const AVATAR_DOMAIN = isProd
  ? 'https://ssl-avatar2.720static.com'
  : 'https://ssl-avatar0.720static.com';

export const PUBLIC_DOMAIN = 'https://ssl-static2.720static.com';

export const API_SEARCH_DOMAIN = isProd
  ? 'https://api-search.720yun.com'
  : 'https://api-search-test.720yun.com';
